import { useTheme } from 'foundations-theming/utils';
import ChatWidgetPreview from 'conversations-visitor-experience-components/presentation-components/chat-widget-preview/ChatWidgetPreview';
// @ts-expect-error Library not migrated yet
import WidgetData from 'conversations-internal-schema/widget-data/records/WidgetData';
// @ts-expect-error Library not migrated yet
import Message from 'conversations-internal-schema/message/records/Message';
import { buildChatHeadingConfigFromType } from 'conversations-internal-schema/chat-heading-config/builders/buildChatHeadingConfigFromType';
import { List, Map as ImmutableMap } from 'immutable';
import ColoringRecord from 'conversations-internal-schema/coloring/records/ColoringRecord';
import { COMPANY } from 'conversations-internal-schema/chat-heading-config/constants/ChatHeadingConfigTypes';
// @ts-expect-error Library not migrated yet
import ThreadHistory from 'conversations-message-history/thread-history/records/ThreadHistory';
import CommonMessage from 'conversations-message-history/common-message-format/records/CommonMessage';
import { AGENT_SENDER as AGENT_SENDER_TYPE, VISITOR_SENDER as VISITOR_SENDER_TYPE } from 'conversations-message-history/common-message-format/constants/cmfSenderTypes';
// @ts-expect-error Library not migrated yet
import { buildInitialMessage } from 'conversations-message-history/initial-message/operators/buildInitialMessage';
import { buildSenderLocator } from 'conversations-message-history/senders/operators/buildSenderLocator';
import I18n from 'I18n';
import { AGENT } from 'conversations-message-history/common-message-format/constants/legacySenderTypes';
// @ts-expect-error Bender-loader not migrated yet
import avatarSrc from 'bender-url!../../img/avatar.jpg';
import ChatPreviewWrapper from './ChatPreviewWrapper';
import { jsx as _jsx } from "react/jsx-runtime";
export default function LiveChatSample() {
  const trellisTheme = useTheme();
  const VISITOR_SENDER = ImmutableMap({
    '@type': VISITOR_SENDER_TYPE,
    utk: 'some-utk',
    id: 1
  });
  const AGENT_SENDER = ImmutableMap({
    '@type': AGENT_SENDER_TYPE,
    utk: 'some-utk',
    avatar: avatarSrc,
    firstName: 'Johnny',
    id: 2
  });
  const mockedThreadHistory = new ThreadHistory({
    messages: {
      results: [buildInitialMessage({
        text: I18n.text('app.landingPage.sample.message1'),
        timestamp: 1539958294995
      }), new CommonMessage({
        sender: VISITOR_SENDER,
        timestamp: 1539958294995,
        text: I18n.text('app.landingPage.sample.message2')
      }), new CommonMessage({
        sender: AGENT_SENDER,
        timestamp: 1539958354995,
        text: I18n.text('app.landingPage.sample.message3')
      })],
      hasMore: false
    }
  });
  return /*#__PURE__*/_jsx(ChatPreviewWrapper, {
    children: size => /*#__PURE__*/_jsx(ChatWidgetPreview, {
      previewAwayMessage: "",
      showingHsBranding: false,
      senders: ImmutableMap().set(buildSenderLocator(AGENT, 2), {
        data: AGENT_SENDER
      }),
      widgetData: new WidgetData({
        message: new Message({
          initialMessage: I18n.text('app.landingPage.sample.message1'),
          chatHeadingConfig: buildChatHeadingConfigFromType(COMPANY, {
            companyLogoUrl: avatarSrc,
            customChatName: I18n.text('app.landingPage.sample.name')
          })
        }),
        sendFrom: List(),
        coloring: ColoringRecord({
          accentColor: trellisTheme.color['do-not-use-calypso-dark'],
          textColor: 'white',
          useDefaultColor: false
        })
      }),
      threadHistory: mockedThreadHistory,
      mobile: false,
      onClose: () => {},
      size: size,
      availabilityMessageDetails: {
        showAvailabilityMessage: false,
        previewResponseTimeText: I18n.text('app.landingPage.sample.responseTime')
      }
    })
  });
}